import React from 'react';
import { CalendarDays } from 'lucide-react';
import MonthGrid from '../MonthGrid';
import { formatMonthName, parseISODate } from '../../../../utils/journeyDates';
import styles from './YearGrid.module.css';

const MONTHS = Array.from({ length: 12 }, (unused, index) => index);

// Twelve months of the same grid. The API returns an empty `cells` array and no
// message for a year with nothing in it, so the empty state is written here.
const YearGrid = ({ period, cells = [], onSelectMonth }) => {
	const year = parseISODate(period.start).getFullYear();

	const ratingsByDate = cells.reduce((map, cell) => {
		map[cell.date] = cell.rating;
		return map;
	}, {});

	if (cells.length === 0) {
		return (
			<div className={styles.empty}>
				<CalendarDays className={styles.emptyIcon} />
				<p className={styles.emptyTitle}>Nothing tracked in {year} yet</p>
				<p className={styles.emptyText}>
					Once you start rating how you feel, every day of the year shows up
					here — one square per day, coloured by how heavy that day was.
				</p>
			</div>
		);
	}

	return (
		<div className={styles.year}>
			{MONTHS.map((monthIndex) => (
				<div key={monthIndex} className={styles.monthCard}>
					{onSelectMonth ? (
						<button
							type='button'
							className={styles.monthLink}
							onClick={() =>
								onSelectMonth(
									`${year}-${String(monthIndex + 1).padStart(2, '0')}-01`
								)
							}
						>
							{formatMonthName(monthIndex)}
						</button>
					) : (
						<h4 className={styles.monthHeading}>{formatMonthName(monthIndex)}</h4>
					)}
					<MonthGrid
						year={year}
						monthIndex={monthIndex}
						ratingsByDate={ratingsByDate}
						cellSize={16}
						compact
					/>
				</div>
			))}
		</div>
	);
};

export default YearGrid;
